import MaterialIconsWoff2 from 'material-icons/iconfont/material-icons.woff2';
import MaterialIconsOutlinedWoff2 from 'material-icons/iconfont/material-icons-outlined.woff2';

const css = `
@font-face {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: 400;
  src: url("${MaterialIconsWoff2}") format("woff2");
  font-display: block;
}

@font-face {
  font-family: "Material Icons Outlined";
  font-style: normal;
  font-weight: 400;
  src: url("${MaterialIconsOutlinedWoff2}") format("woff2");
  font-display: block;
}

/* filled */
.material-icons {
  font-family: "Material Icons";
}

/* outlined */
.material-icons-outlined,
.material-icons--outlined {
  font-family: "Material Icons Outlined";
}
`;

const style = document.createElement('style');
style.textContent = css;
document.head.appendChild(style);